import React, {PureComponent} from 'react';
import './index.css';
import {withTranslation} from 'react-i18next';
import Select from 'react-select';
import Loading from '../subComponents/GenericLoading/loading';
import ArrowLeft from "../../assets/arrow-left.png";
import ArrowRight from "../../assets/arrow-right.png";
import Trash from '../../assets/trash.png'
import Edit from '../../assets/edit.png'
import video from "../../assets/video.png";
import makeAnimated from 'react-select/animated';
import Connect from "react-redux/es/connect/connect";
import {getAllMultimedia, getMultimedia} from "../../actions";
import {
	dispatchOnMultimediaGetFiles,
	dispatchOnMultimediaGetFilesFailure,
	dispatchOnMultimediaGetFilesSuccess,
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileFailure,
	dispatchOnMultimediaCreateFileSuccess,
	dispatchOnMultimediaSelectFile,
	dispatchOnMultimediaFilterChanged,
	dispatchOnMultimediaEditFileModeChanged,
	dispatchOnMultimediaAddFileModeChanged,
	dispatchOnMultimediaEditFile,
	dispatchOnMultimediaEditFileSuccess,
	dispatchOnMultimediaEditFileFailure,
	dispatchOnMultimediaRemoveFileModeChanged,
	dispatchOnMultimediaRemoveFile,
	dispatchOnMultimediaRemoveFileSuccess,
	dispatchOnMultimediaRemoveFileFailure,
	dispatchOnMultimediaUnselectFile,
	dispatchOnMultimediaReplaceFile,
	dispatchOnMultimediaClearSelectedFiles,
	dispatchOnMultimediaSearchChanged,
} from "./functions";
import Pagination from "../subComponents/GenericPagination";
import Config from "../../config";
import PropTypes from "prop-types";
import SuperModal from "../subComponents/GenericModal/superModal";
import {debug, find} from "../../utility/functions";
import FileComponent from "./file";
import Image from "react-bootstrap/Image";
import {GET_SCHOOL_FILES} from "../../api";

export const fileOptions = [
	{value: undefined, label: 'Todos'},
	{value: 'image', label: 'Imagens'},
	{value: 'video', label: 'Videos'}
];

class Multimedia extends PureComponent {

	// Native component functions

	componentDidMount() {
		this.onGetAllMultimedia();
	}

	componentWillUnmount(): void {
		this.fileComponent = undefined;
		this.props.dispatchOnMultimediaClearSelectedFiles();
		this.props.dispatchOnMultimediaSearchChanged(null);
	}

	// Custom component functions

	// Fetches all multimedia from the api and dispatches functions to redux according to the result
	onGetAllMultimedia = (url, params = {}) => {
		const {filterOverride, limit, search} = this.props;
		this.props.dispatchOnMultimediaGetFiles();
		if (filterOverride) params["filter"] = filterOverride;
		if (limit) params["limit"] = limit;
		if (search) params['search'] = search;
		getAllMultimedia(url, params)
			.then((response) => {
				this.props.dispatchOnMultimediaGetFilesSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnMultimediaGetFilesFailure(error);
			})
	};

	onGetMultimedia = (file, index) => {
		getMultimedia(find(file, 'id'))
			.then(response => {
				this.props.dispatchOnMultimediaEditFileModeChanged(true, file, index);
			})
			.catch(error => {

			})
	};

	// This function is called when 'Add files' button is clicked
	onAddFilesButtonPressed = () => {
		this.props.dispatchOnMultimediaAddFileModeChanged(true);
	};

	// This function is called when filter dropdown value is changed
	onFilterChanged = (filter) => {
		this.props.dispatchOnMultimediaFilterChanged(filter);
		this.onGetAllMultimedia(null, {filter: filter.value})
	};

	// This function is called when a file is clicked
	onFileClicked = (file) => {
		const {selecting, multiSelect, selectedFiles} = this.props;
		if (!selecting) return;

		const isSelected = this.isFileSelected(file);

		if(!isSelected){
			if(!multiSelect) {
				this.props.dispatchOnMultimediaReplaceFile(file)
			} else {
				this.props.dispatchOnMultimediaSelectFile(file);
			}
			if (this.props.onFileSelected) {
				this.props.onFileSelected(selectedFiles, file);
			}
		} else {
			this.props.dispatchOnMultimediaUnselectFile(file);
		}
	};

	// This function verifies whether a file is selected or not
	isFileSelected = (file) => {
		const {selectedFiles, multiSelect} = this.props;

		if(!selectedFiles) return false;

		if(multiSelect) {
			return selectedFiles.some((f) => {
				return find(f, 'id') === find(file, 'id')
			});
		}

		return find(selectedFiles[0], 'id') === find(file, 'id')
	};

	onSearchStringSubmited = (e) => {
		if(e.key === 'Enter') {
			this.onGetAllMultimedia();
			e.preventDefault();
		}
	};

	render() {
		return (
			<div>
				<div className="container-multimedia">
					{this.renderTitle()}
					<div className="container-multimedia-body">
						<div className="container-multimedia-actions">
							{this.renderAddFiles()}
							{this.renderFilter()}
							{this.renderSearch()}
						</div>
						{this.renderBody()}
					</div>
				</div>
				{this.renderAddFilesModal()}
				{this.renderEditFilesModal()}
				{this.renderRemoveFilesModal()}
			</div>
		);
	}

	renderBody = () => {
		const {loading, files} = this.props;



		if(loading || !files) {
			return (
				<div className={'multimedia-loading-container'}>
					<Loading size={"medium-spinner"} color={"blue"}/>
				</div>
			)
		}

		return(
			<div className="container-multimedia-body-files">
				<div className="container-multimedia-body-files-container">
					{this.renderFiles()}
				</div>
				{this.renderPaginationButtons()}
			</div>
		)
	};

	renderTitle = () => {
		if (this.props.showTitle) {
			const {t} = this.props;
			return (
				<div className="container-news-header">
					<div className="container-news-header-tittle"><h2>{t('Multimedia')}</h2></div>
				</div>
			)
		}
	};

	renderAddFiles = () =>  {
		if (this.props.showAddFiles) {
			const {t} = this.props;
			return (
				<label className="button-multimedia-add-files" htmlFor="addfile"
				       onClick={this.onAddFilesButtonPressed}>{"+" + t("Add Files")}</label>
			)
		}
	};

	renderFilter = () =>  {
		if (this.props.showFilter) {
			const animatedComponents = makeAnimated();
			return (
				<Select
					className="select-multimedia-filter"
					components={animatedComponents}
					options={fileOptions}
					onChange={this.onFilterChanged}
					defaultValue={fileOptions[0]}
				/>
			)
		}
	};

	renderSearch = () =>  {
		const {t} = this.props;
		return(
			<input
				type={'text'}
				className='form-control input-multimedia-search'
				placeholder={t("Search")}
				onChange={(e) => {
					this.props.dispatchOnMultimediaSearchChanged(e.target.value);
					e.stopPropagation()
				}}
				onKeyDown={this.onSearchStringSubmited}
			/>
		)
	};

	renderFiles = () =>  {
		const {files, filter, selecting, t} = this.props;

		if (files.length === 0) {
			const fileType = filter !== null ? filter.label : t("Files");
			return (
				<div style={{display: "flex"}}>
					{"Não existem " + fileType + " na multimedia"}
				</div>
			)
		}

		return files.map((file, index) => {
			const isSelected = this.isFileSelected(file);
			const className = isSelected && selecting ? " files-container-selected" : "";
			return (
				<div key={find(file, 'id')}
				     className={"files-container" + className}
				     onClick={() => {
					     this.onFileClicked(file)
				     }}
				>
					{this.renderType(file, index, isSelected)}
				</div>
			)
		});
	};

	renderPaginationButtons = () =>  {
		const {pagination} = this.props;
		if (pagination) {
			const {current_page, last_page} = this.props.pagination;
			return (
				<Pagination
					totalPages={last_page}
					currentPage={current_page}
					baseUrl={Config.urlApi + GET_SCHOOL_FILES}
					onPageChanged={(url) => {
						this.onGetAllMultimedia(url)
					}}
				/>
			)
		}
	};

	renderAddFilesModal = () =>  {
		const {t, adding, uploading} = this.props;
		if (adding) {
			return (
				<SuperModal
					size={"xl"}
					title={t("Add File")}
					onOkPressed={() => {
						if(this.fileComponent) this.fileComponent.onCreateMultimedia();
					}}
					onCloseModal={() => {
						if(this.fileComponent) this.fileComponent.clearForm();
						this.props.dispatchOnMultimediaAddFileModeChanged(false)
					}}
					okLoading={uploading}
					okButtonText={t("Upload Files")}
					cancelButtonText={t("Cancel")}
					bodyClassName={'modal-multimedia-body'}
				>
					<FileComponent
						childRef={ref => this.fileComponent = ref}
						showFilePicker
					/>
				</SuperModal>
			)
		}
	};

	renderEditFilesModal = () =>  {
		const {t, editing, uploading, file} = this.props;
		if (editing) {
			return (
				<SuperModal
					size={"lg"}
					title={t("Edit File")}
					onOkPressed={() => {
						if(this.fileComponent) this.fileComponent.onEditMultimedia()
					}}
					onCloseModal={() => {
						if(this.fileComponent) this.fileComponent.clearForm();
						this.props.dispatchOnMultimediaEditFileModeChanged(false)
					}}
					okLoading={uploading}
					okButtonText={t("Update File")}
					cancelButtonText={t("Cancel")}
				>
					<FileComponent
						childRef={ref => this.fileComponent = ref}
						edit={true}
					/>
				</SuperModal>
			)
		}
	};

	renderRemoveFilesModal = () =>  {
		const {t, removing, uploading} = this.props;
		if (removing) {
			return (
				<SuperModal
					size={"lg"}
					title={t("Remove File")}
					onOkPressed={() => {
						if(this.fileComponent) this.fileComponent.onRemoveMultimedia();
					}}
					onCloseModal={() => {
						if(this.fileComponent) this.fileComponent.clearForm();
						this.props.dispatchOnMultimediaRemoveFileModeChanged(false)
					}}
					okLoading={uploading}
					okButtonText={t("Remove File")}
					okButtonVariant={"danger"}
					cancelButtonText={t("Cancel")}
				>
					<FileComponent
						childRef={ref => this.fileComponent = ref}
						remove={true}
					/>
				</SuperModal>
			)
		}
	};

	renderActions = (file, index, actions) => {
		const {canEditFiles, canRemoveFiles} = this.props;
		if(canEditFiles || canRemoveFiles) {
			return(
				<div className='files-container-actions'>
					{this.renderFileEdit(file, index, actions)}
					{this.renderFileRemove(file, index, actions)}
				</div>
			)
		}
	};

	renderFileEdit(file, index, actions) {
		const {canEditFiles} = this.props;
		if (canEditFiles && actions) {
			return(
				<img
					className='files-container-action-edit'
					src={Edit}
					alt={""}
					onClick={() => {
						this.onGetMultimedia(file, index)
					}}
				/>
			)
		}
	}

	renderFileRemove = (file, index, actions) => {
		const {canRemoveFiles} = this.props;
		if (canRemoveFiles && actions) {
			return(
				<img
					className='files-container-action-remove'
					src={Trash}
					alt={""}
					onClick={() => {
						this.props.dispatchOnMultimediaRemoveFileModeChanged(true, file, index);
					}}
				/>
			)
		}
	};

	renderImageFile = (file, index, selected, actions) => {
		return (
			<div>
				<div className="files-container-image">
					<Image
						key={'multimedia-image' + find(file, 'id') + index}
						className='img-multimedia-files'
						src={Config.urlImages + find(file, 'src')}
					/>
				</div>
				<div className='files-container-bottom'>
					<span className="files-container-span">{find(file, 'name')}</span>
					{this.renderActions(file, index, actions)}
				</div>
			</div>
		)
	};

	renderVideoFile = (file) => {
		return (
			<div>
				<div className="files-container-video">
					<img height='150' width='150' src={video} alt={""}/>
					{this.renderFileRemove()}
					{this.renderFileEdit()}
				</div>
				<span className="files-container-span">{file.data.name}</span>
			</div>
		);
	};

	renderType = (file, index, selected, actions = true) => {
		const type = find(file, 'mimetype');
		if(type !== undefined) {
			if(type.includes("image")) return this.renderImageFile(file, index, selected, actions);
			if(type.includes("video")) return this.renderVideoFile(file, index, selected, actions);
		}

		return null;
	}
}

Multimedia.propTypes = {
	filterOverride: PropTypes.oneOf([
		null,
		"image",
		"video",
	]),
	showAddFiles: PropTypes.bool,
	showFilter: PropTypes.bool,
	showTitle: PropTypes.bool,
	selecting: PropTypes.bool,
	multiSelect: PropTypes.bool,
	onFileSelected: PropTypes.func,
	limit: PropTypes.number,
	canEditFiles: PropTypes.bool,
	canRemoveFiles: PropTypes.bool,
};

Multimedia.defaultProps = {
	filterOverride: null,
	selecting: false,
	multiSelect: false,
	showAddFiles: true,
	showFilter: true,
	showTitle: true,
	limit: null,
	canEditFiles: true,
	canRemoveFiles: true,
};

const mapStateToProps = store => ({
	loading: store.multimediaReducer.loading,
	filter: store.multimediaReducer.filter,
	files: store.multimediaReducer.files,
	pagination: store.multimediaReducer.pagination,
	selectedFiles: store.multimediaReducer.selectedFiles,
	adding: store.multimediaReducer.adding,
	editing: store.multimediaReducer.editing,
	removing: store.multimediaReducer.removing,
	name: store.multimediaReducer.name,
	author: store.multimediaReducer.author,
	file: store.multimediaReducer.file,
	uploading: store.multimediaReducer.uploading,
	search: store.multimediaReducer.search,
});

const mapFunctionsToProps = {
	dispatchOnMultimediaGetFiles,
	dispatchOnMultimediaGetFilesSuccess,
	dispatchOnMultimediaGetFilesFailure,
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileSuccess,
	dispatchOnMultimediaCreateFileFailure,
	dispatchOnMultimediaEditFile,
	dispatchOnMultimediaEditFileSuccess,
	dispatchOnMultimediaEditFileFailure,
	dispatchOnMultimediaRemoveFile,
	dispatchOnMultimediaRemoveFileSuccess,
	dispatchOnMultimediaRemoveFileFailure,
	dispatchOnMultimediaSelectFile,
	dispatchOnMultimediaUnselectFile,
	dispatchOnMultimediaReplaceFile,
	dispatchOnMultimediaClearSelectedFiles,
	dispatchOnMultimediaFilterChanged,
	dispatchOnMultimediaAddFileModeChanged,
	dispatchOnMultimediaEditFileModeChanged,
	dispatchOnMultimediaRemoveFileModeChanged,
	dispatchOnMultimediaSearchChanged,
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(Multimedia));
